import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styles: [],
})
export class FooterComponent implements OnInit {
  year = signal(new Date().getFullYear());
  logoSrc: string = '';

  ngOnInit() {
    const themeMode = localStorage.getItem('themeMode') || 'light';
    if (themeMode === 'dark') {
      this.logoSrc = '../../../assets/img/logo-dark.png';
    } else {
      this.logoSrc = '../../../assets/img/logo.png';
    }
  }
}
